import {API_BASE_URL} from "../../constants";

export const getImageUrl = (image) => {
  return API_BASE_URL + "/image/" + image.uuid;
}
